import cloneDeep from 'lodash/cloneDeep';

// 动作类型
export const ACTION_TYPE = {
    ACTION_REPLY: 1, // 系统自动回复
    ACTION_APPLET: 2, // 跳转小程序
    ACTION_VISITOR: 3, // 访客快速发送
    ACTION_WEB: 4, // 跳转网页
    ACTION_SYSTEM: 99, // 系统事件
};

// 自动回复类型
export const REPLY_TYPE = {
    REPLY_TXT: 1,
    REPLY_IMG: 2,
    REPLY_IMGTXT: 3,
    REPLY_APPLETPLUGIN: 10,
};

export const APPID_INPUT_MAX_LENGTH = 255;
export const PAGEPATH_INPUT_MAX_LENGTH = 255;
export const SYSTEMEVNT = ['退出排队', '结束会话', '服务评价'];
export const SYSTEMEVNT_ECOMMERCE = ['电商订单列表', '电商商品列表'];
export const CHANNEL_WEB = 0;
export const CHANNEL_APPLET = 1;
export const SYSTEMEVENTTIPKEY = 'SYSTEMEVENTTIPKEY';


export const DEFAULT_NAV_MENU = {
    // 注意，value会在排序的时候需要用到
    value: 0,
    name: '',
    action: ACTION_TYPE.ACTION_REPLY,
    meta: {},
    error: null, // 注意，这里将error设置为null，来标识按钮是否刚被添加，切勿修改
    placeholder: '按钮1',
};

// 导航默认设置
export const DEFAULT_NAV_SETTIGN = {
    // 默认值
    enableSwitch: false,
    color: {
        value: 0,
        color: '#566076',
    },
    menu: {
        // 默认存在一个空菜单
        list: [cloneDeep(DEFAULT_NAV_MENU)],
    },
};

/** 校验规则 */
export const VALID_REG = {
    url: /^(https?|ftp|file|tel|mailto):(\/\/)?[^\s/$.?#].[^\s]*$/i, // 支持mailto, tel
    wxAppId: /^(?![a-zA-Z]+$)(?![0-9]+$)[0-9A-Za-z]{18}$/,
    wxAppPath: /^[^\/][0-9a-zA-Z\$\-\_\.\+\!\*\'\(\)\,\&\^\/\?\=\[\]]+$/,
    menuName: /.{2,8}/,
};